import {FrameworkProfileId, FrameworkProfile} from "../../Types";
import {CURRENT_REGION} from "../../utils/region";
import jsonApi from "../jsonApi";

export async function get(frameworkProfileId: FrameworkProfileId): Promise<FrameworkProfile> {
  return jsonApi.get(`/region/${CURRENT_REGION}/api/tprm/framework_profiles/${frameworkProfileId}`);
}
